import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HasStatusType } from '@app/shared/popup/has-status-type';

@Component({
    templateUrl: './organization-space-delete-modal.component.html',
    standalone: false
})
export class OrganizationSpaceDeleteModalComponent extends HasStatusType {
  public deleteSpaceForm: FormGroup<{ deleteMode: FormControl<'deleteSpaceAndChildren' | 'deleteSpaceOnly'> }>;

  constructor() {
    const data = inject<{ type: string; }>(MAT_DIALOG_DATA);
    super(data.type);

    this.deleteSpaceForm = new FormGroup({
      deleteMode: new FormControl(null, Validators.required)
    });
  }

  /**
   * Get form data to use for deleting a Space.
   * @return Delete Space form data.
   */
  public getGeneratedObject(): { deleteMode: 'deleteSpaceAndChildren' | 'deleteSpaceOnly' } {
    return {deleteMode: this.deleteSpaceForm.controls.deleteMode.value};
  }
}
